import CustomAmplitudeClient from "./custom-amplitude-client.0520d7b5cfdf.js";
import"./backdrop-dialog.4063af820582.js";

export class PriceVerification {
  constructor() {
    this.config = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);

    this.elements = {
      priceVerificationButtons: document.querySelectorAll(
        ".price-verification",
      ),
      priceVerificationModal: document.getElementById(
        "price-verification-modal",
      ),
    };

    this.bindListeners();
  }

  bindListeners() {
    this.elements.priceVerificationButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        const dataset = e.target.parentElement.dataset;
        const page = dataset.page;
        const properties = {
          service_code: dataset.service,
          provider_id: dataset.providerid,
        };
        this.amplitudeClient.trackEngageVerifyPrice(page, properties);
        this.elements.priceVerificationModal.showModal();
      });
    });
  }
}
